/** Project time report subtotal grouping criteria */
export enum ProjectTimeReportSubtotalByEnum {
  /** Subtotal by project / task entity */
  PROJECT = 'PROJECT',
  /** Subtotal by user */
  USER = 'USER',
  /** Subtotal by direction */
  DIRECTION = 'DIRECTION',
  /** Subtotal by unit */
  UNIT = 'UNIT',
  /** Subtotal by client */
  CLIENT = 'CLIENT',
}
